export const localeSpecificMenuItems = [
    'stationLocator',
    'specialOffer',
    'blog',
];